export const buildProvenance = { "commitHash": "39afff56ea97e3fe579225dc157c499f0d5d4f77", "branchName": "refs/heads/release/2025.1", "buildDate": "2025-04-04T10:35:05.229Z", "version": "2025.1.10012" };
